import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { ERROR_NOTIFICATION_CODES } from 'utils';

interface DataError {
  data: { [key: string]: string[] };
}

export interface errorNotificationState {
  isOpen: boolean;
  error: AxiosError | null;
  dataErrors: CommonResponse<DataError> | undefined;
  dataMessage: CommonResponse<null> | undefined;
}

const initialState: errorNotificationState = {
  isOpen: false,
  error: null,
  dataErrors: undefined,
  dataMessage: undefined,
};

const errorNotificationSlice = createSlice({
  name: 'error_notification',
  initialState,
  reducers: {
    setError(state, action: PayloadAction<AxiosError>) {
      if (ERROR_NOTIFICATION_CODES.includes(Number(action.payload.response?.status))) {
        state.isOpen = true;
        state.error = action.payload;
      }
      const axiosError = action.payload as AxiosError<CommonResponse<DataError>>;
      const commonRes = axiosError.response?.data;
      if (commonRes) {
        state.dataErrors = commonRes;
      }
    },
    hideError(state) {
      state.isOpen = false;
      state.error = null;
      state.dataErrors = undefined;
    },

    setMessage(state, action: PayloadAction<CommonResponse<null>>) {
      const commonRes = action.payload;
      if (commonRes) {
        state.dataMessage = commonRes;
      }
    },
    clearMessage(state) {
      state.dataMessage = undefined;
    },
  },
});

// Actions
export const errorNotificationActions = errorNotificationSlice.actions;

export const { clearMessage, hideError } = errorNotificationSlice.actions;

// Selectors
export const selectErrorNotificationIsOpen = (state: RootState) => state.errorNotification.isOpen;
export const selectErrorNotificationError = (state: RootState) => state.errorNotification.error;
export const selectDataErrorResponse = (state: RootState) => state.errorNotification.dataErrors;
export const selectMessagesResponse = (state: RootState) => state.errorNotification.dataMessage;

// Reducer
export const errorNotificationReducer = errorNotificationSlice.reducer;
